import { type IntegrationData } from 'src/shared/api/integrations/factorial';

type GetIsConnectedArgs = {
  isLoading: boolean;
  integrationData?: IntegrationData[];
  subsidiary?: string;
  integrationName: string;
};

export const getIsConnected = ({ isLoading, integrationData, subsidiary, integrationName }: GetIsConnectedArgs) => {
  if (isLoading) return false;

  const integrationBySubsidiary = integrationData?.filter(e => e.subsidiary === subsidiary);

  const isConnected =
    integrationBySubsidiary?.some(e => e.flowsEnabled?.general) &&
    integrationBySubsidiary?.some(e => e.software === integrationName);

  return isConnected;
};
